import { FormLabel, Radio, Stack } from '@mui/material';
import { RadioGroup } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { FormControl } from '@mui/material';
import { FieldProp } from 'react-typed-form';

type Props<T extends string | boolean> = {
  field: FieldProp<T>;
  options: Array<{ label: string; value: T }>;
  label?: string;
  required?: boolean;
  vertical?: boolean;
  disabled?: boolean;
} & React.ComponentProps<typeof RadioGroup>;

export default function FieldRadioGroup<T extends string | boolean>({
  field,
  options,
  label,
  required,
  vertical,
  disabled,
  ...props
}: Props<T>) {
  return (
    <FormControl>
      <Stack gap={0.5}>
        <FormLabel required={required}>{label ?? field.label}</FormLabel>
        <RadioGroup
          {...props}
          value={String(field.value)}
          onChange={(_e, value) =>
            field.handleValueChange(
              (value === 'true'
                ? true
                : value === 'false'
                  ? false
                  : value) as T,
            )
          }
          row={!vertical}
          sx={{ ml: 1 }}
        >
          {options.map((option) => (
            <FormControlLabel
              key={String(option.value)}
              control={<Radio value={String(option.value)} />}
              label={option.label}
              disabled={disabled}
            />
          ))}
        </RadioGroup>
      </Stack>
    </FormControl>
  );
}
